import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonEn from './locales/en/common.json';
import adminEn from './locales/en/admin.json';
import crmEn from './locales/en/crm.json';
import superEn from './locales/en/super.json';
import academyEn from './locales/en/academy.json';
import guardianEn from './locales/en/guardian.json';
import authEn from './locales/en/auth.json';
import publicEn from './locales/en/public.json';
import pdfEn from './locales/en/pdf.json';
import plyrmatchEn from './locales/en/plyrmatch.json';
import mentorshipEn from './locales/en/mentorship.json';
import leadBotEn from './locales/en/leadBot.json';

import commonEs from './locales/es/common.json';
import adminEs from './locales/es/admin.json';
import crmEs from './locales/es/crm.json';
import superEs from './locales/es/super.json';
import academyEs from './locales/es/academy.json';
import guardianEs from './locales/es/guardian.json';
import authEs from './locales/es/auth.json';
import publicEs from './locales/es/public.json';
import pdfEs from './locales/es/pdf.json';
import plyrmatchEs from './locales/es/plyrmatch.json';
import mentorshipEs from './locales/es/mentorship.json';
import leadBotEs from './locales/es/leadBot.json';

export const SUPPORTED_LANGUAGES = ['en', 'es'];
export const LANGUAGE_STORAGE_KEY = 'iap_lang';

function detectInitialLanguage() {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (stored && SUPPORTED_LANGUAGES.includes(stored)) return stored;
  } catch {
    // localStorage unavailable — fall through to browser detection
  }
  const browserLang = (navigator.language || 'en').slice(0, 2).toLowerCase();
  return SUPPORTED_LANGUAGES.includes(browserLang) ? browserLang : 'en';
}

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: commonEn,
      admin: adminEn,
      crm: crmEn,
      super: superEn,
      academy: academyEn,
      guardian: guardianEn,
      auth: authEn,
      public: publicEn,
      pdf: pdfEn,
      plyrmatch: plyrmatchEn,
      mentorship: mentorshipEn,
      leadBot: leadBotEn,
    },
    es: {
      common: commonEs,
      admin: adminEs,
      crm: crmEs,
      super: superEs,
      academy: academyEs,
      guardian: guardianEs,
      auth: authEs,
      public: publicEs,
      pdf: pdfEs,
      plyrmatch: plyrmatchEs,
      mentorship: mentorshipEs,
      leadBot: leadBotEs,
    },
  },
  lng: detectInitialLanguage(),
  fallbackLng: 'en',
  ns: ['common', 'admin', 'crm', 'super', 'academy', 'guardian', 'auth', 'public', 'pdf', 'plyrmatch', 'mentorship', 'leadBot'],
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

export default i18n;
